<div class="item-container">
    <div class="item-header">
      <h5 class="text-center">{{"View Comments" | translate}}</h5>
      <div class="edit-icons" mat-dialog-close="">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="item-content d-flex flex-column p-2" >
        <div class="d-box">
           <h4 class="text-center mt-3">{{dialogData.p_n}}</h4>
          <div class="i-content mt-3" [innerHTML]="dialogData.adm_comm  | safe:'html'"></div>
        </div>
     
    </div>
</div>